<script>
import _merge from 'lodash/merge'
import _cloneDeep from 'lodash/cloneDeep'

import ProductItemParamItem from './ProductItemParamItem'
export default {
  components: { ProductItemParamItem },

  props: {
    data: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: () => {},
    },
    maxValue: {
      type: Number,
      required: true,
    },
    valueSizeTotal: {
      type: Number,
      default: 0,
    },
    valuePriceTotal: {
      type: Number,
      default: 0,
    },
    selectPrepaid: {
      type: Object,
      default: () => {},
    },
    payMethodType: {
      type: String,
      default: '',
    },
    payMethod: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      /* valueSizeTotal: '',
      valuePriceTotal: '', */
    }
  },
  computed: {
    paramsWithQty() {
      return _merge(_cloneDeep(this.data), this.value);

    },
    paramsWithoutNoQty() {
      return Object.values(this.paramsWithQty).filter((param) => param.selectQty)
    },
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.updateTotal(value);
      },
    },
  },
  mounted() {
    this.updateTotal(this.value);
  },
  methods: {
    updateTotal(paramsValue) {
      const getPropTotal = (property) => {
        const qtyPropArray = Object.values(paramsValue).map((param) => {
          return param.selectQty * param[property]
        });

        return qtyPropArray.length !== 0
          ? qtyPropArray.reduce((prev, curr) => prev + curr)
          : 0
      };

      // this.valueSizeTotal = getPropTotal('size')
      // this.valuePriceTotal = getPropTotal('price')

      this.$emit('update:valueSizeTotal', getPropTotal('size'));
      this.$emit('update:valuePriceTotal', getPropTotal('price'));
    },
    handleParamMaxQty(size) {
      // maxValue: 人數 && 方案抵用剩餘次數, valueSizeTotal: 憑證總數
      const selectPrepaidMax =
        this.selectPrepaid.prices && Object.keys(this.selectPrepaid.prices).length > 0
        ? this.selectPrepaid.times - this.selectPrepaid.used
        : 0;

      const maxValue = selectPrepaidMax < this.maxValue && this.payMethodType === 'prepaid'
        ? selectPrepaidMax
        : this.maxValue;

      const restSize = maxValue - this.valueSizeTotal;

      const selectedSize = restSize >= size ? Math.floor(this.valueSizeTotal / size) : 0;

      return Math.floor(restSize / size) + selectedSize
    },
    updateSelectedValue(selectQty, param) {
      const _tempValue = Object.assign({}, this.value);
      const paramIsSelected = this.value[param.alias];
      const paramObj = {
        ...param,
        selectQty,
      };
      if (paramIsSelected && selectQty === 0) {
        delete _tempValue[param.alias]
      } else {
        _tempValue[param.alias] = paramObj
      }

      // 找到一個大於0的
      if(Object.values(_tempValue).some(item => {return item.selectQty > 0})) {
        const setPayMethod = this.payMethodType;

        this.$emit('setPayMethod', setPayMethod);
      }else {
        this.$emit('setPayMethod', '');
      }




      this.$emit('update:value', _tempValue);
    },
  },
}
</script>

<template>
  <div>
    <ProductItemParamItem
      v-for="(param, paramKey) in paramsWithQty"
      :key="paramKey"
      :data="param"
      :select-qty="(payMethodType === payMethod && payMethod) ? param.selectQty : 0"
      :max-qty="handleParamMaxQty(param.size)"
      :pay-method-type="payMethodType"
      @change="(selectQty) => {
        updateSelectedValue(selectQty, param)
      }"
    />
  </div>
</template>
